import type { PlanetType } from "../entities";

/** A map in sim coordinates (y-down, origin top-left). This is also the JSON map format. */
export interface MapDef {
	name: string;
	size: { w: number; h: number };
	planets: PlanetDef[];
	spawnPoints: PointDef[];
	/** Fueling stations (I-026): persistent map objects that refuel a lingering ship, never consumed. */
	fuelItems: FuelItemDef[];
	/** The map's own asteroid field (P11.12); missing fields keep the legacy values. */
	asteroids?: AsteroidSettings;
}

export interface AsteroidSettings {
	/** Most asteroids on the map at once (legacy: no limit). */
	max?: number;
	/** Arrivals per minute, 0 = none (legacy: one per 201 ticks ≈ 19.9). */
	perMinute?: number;
	/** Average launch speed in units/tick (legacy: 3, drawn from [0, 6)). */
	speed?: number;
}

export interface PointDef {
	x: number;
	y: number;
}

export interface PlanetDef extends PointDef {
	type: PlanetType;
	mass: number;
	radius: number;
}

export interface FuelItemDef extends PointDef {
	/** Fuel given per tick to any ship within FUEL_STATION_RANGE of this station. */
	amount: number;
}

export const PLANET_TYPES: readonly PlanetType[] = ["mars", "earth", "pluto"];

export class MapFormatError extends Error {
	constructor(message: string) {
		super(message);
		this.name = "MapFormatError";
	}
}
